import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 40C11 56.0163 23.9837 69 40 69C56.0163 69 69 56.0163 69 40C69 23.9837 56.0163 11 40 11C23.9837 11 11 23.9837 11 40ZM9 40C9 22.8792 22.8792 9 40 9C57.1208 9 71 22.8792 71 40C71 57.1208 57.1208 71 40 71C22.8792 71 9 57.1208 9 40Z",
			fill: "#D0D0D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 37.5L41 55C41 55.5523 40.5523 56 40 56C39.4477 56 39 55.5523 39 55L39 37.5C39 36.9477 39.4477 36.5 40 36.5C40.5523 36.5 41 36.9477 41 37.5Z",
			fill: "#D0D0D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40 24C38.8954 24 38 24.8954 38 26C38 27.1046 38.8954 28 40 28C41.1046 28 42 27.1046 42 26C42 24.8954 41.1046 24 40 24Z",
			fill: "#D0D0D2"
		})
	]
});
export default SvgEmptyInfo;
